// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const CycleIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="CycleIcon" ref={forwardedRef} {...props}>
      <path d="m17.166 9.136 1.023-1.024 1.061 1.062L16.425 12 13.6 9.173l1.057-1.059.992.993a5.72 5.72 0 0 0-1.613-3.174 5.7 5.7 0 0 0-3.427-1.648A5.72 5.72 0 0 0 5.65 6.22L4.589 5.158a7.22 7.22 0 0 1 6.185-2.364 7.2 7.2 0 0 1 4.322 2.079 7.22 7.22 0 0 1 2.07 4.263" />
      <path d="M3.575 7.002 6.4 9.83l-1.057 1.059-1.1-1.102a5.72 5.72 0 0 0 1.678 4.276 5.736 5.736 0 0 0 8.79-.807l1.073 1.074A7.233 7.233 0 0 1 4.86 15.123a7.22 7.22 0 0 1-2.12-5.162l-.928.93L.75 9.83z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const CycleIcon = /* @__PURE__ */ Object.assign(CycleIconComponent, {
  displayName: 'CycleIcon',
});
